<ll-toolnavbar>
    <asociacion-toolnavbar></asociacion-toolnavbar>
</ll-toolnavbar>
<ll-titulo>{{ loggedLayoutTitle | easyplaceholder: "Formulario asociaciones" }}</ll-titulo>

<asociaciones-edit [asociacionId]="asociacionId"></asociaciones-edit>
